module.exports = __webpack_public_path__ + "img/gq.79136e4a.svg";